// SPDX-FileCopyrightText: Copyright 2024 Dash0 Inc.

export type ResolvedDocumentationUrl =
	| { kind: "hidden" }
	| { kind: "anchor"; href: string }
	| { kind: "external"; href: string };

export function resolveDocumentationUrl(
	raw: string | undefined,
	currentIntegrationId: string,
): ResolvedDocumentationUrl {
	if (!raw) {
		return { kind: "hidden" };
	}

	if (raw.startsWith("#")) {
		return { kind: "anchor", href: raw };
	}

	if (raw.startsWith("/")) {
		const [path, fragment] = splitFragment(raw);
		// Accept both /hub/integration/<id>/... and /hub/integrations/<id>/... defensively.
		const samePagePattern = new RegExp(
			`^/hub/integrations?/${escapeRegex(currentIntegrationId)}(?:/|$)`,
		);
		if (samePagePattern.test(path)) {
			if (fragment) {
				return { kind: "anchor", href: `#${fragment}` };
			}
			return { kind: "hidden" };
		}
		return { kind: "external", href: raw };
	}

	if (/^https?:\/\//.test(raw)) {
		return { kind: "external", href: raw };
	}

	return { kind: "hidden" };
}

function splitFragment(url: string): [string, string | undefined] {
	const idx = url.indexOf("#");
	if (idx === -1) {
		return [url, undefined];
	}
	return [url.slice(0, idx), url.slice(idx + 1) || undefined];
}

function escapeRegex(input: string): string {
	return input.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
